import * as React from 'react';
import {
    DetailsList,
    DetailsListLayoutMode,
    IDetailsListStyles,
    IDetailsHeaderProps,
    ConstrainMode, IDetailsListProps,
} from '@fluentui/react/lib/DetailsList';
import { IRenderFunction } from '@fluentui/react/lib/Utilities';
import { Sticky } from "@fluentui/react/lib/components/Sticky/Sticky";
import { StickyPositionType } from "@fluentui/react/lib/components/Sticky/Sticky.types";

const gridStyles: Partial<IDetailsListStyles> = {
    root: {
        overflowX: 'scroll',
        selectors: {
            '& [role=grid]': {
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                maxHeight: '60vh',
            },
        },
    },
    headerWrapper: {
        flex: '0 0 auto',
    },
    contentWrapper: {
        flex: '1 1 auto',
        overflowY: 'auto',
        overflowX: 'hidden',
    },
};
const onRenderDetailsHeader: IRenderFunction<IDetailsHeaderProps> = (headerProps, defaultRender) => {
    return <Sticky stickyPosition={StickyPositionType.Header} stickyBackgroundColor="transparent"> <div>{defaultRender!(headerProps)}</div></Sticky>
};



export const SimpleGridStyles: Partial<IDetailsListStyles> = {
    root: {
        overflowX: 'scroll',
        selectors: {
            '& [role=grid]': {
                display: 'flex',
                flexDirection: 'column',

                alignItems: 'start',
                maxHeight: '40vh',
                minHeight: '10'
            },
        },
        border: 'thin solid lightgray',
    },
    headerWrapper: {
        selectors: {
            '.ms-DetailsHeader': {
                paddingTop: '0px',
            },
        }
    },
};


export const StickyDetailsList: React.FunctionComponent<IDetailsListProps> = (props) => {





    return (
        <DetailsList {...props}
            items={props.items}
            columns={props.columns}
            layoutMode={DetailsListLayoutMode.fixedColumns}
            constrainMode={ConstrainMode.unconstrained}
            onRenderDetailsHeader={onRenderDetailsHeader}
            styles={gridStyles}
        />
    );
};